export default {
  props: {
    intervention: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      startTime: null,
      endTime: null,
      interventionData: {
        idMission: null,
        message: null,
        newDateEnd: null,
        newDateStart: null,
      },
      newDateStart: null,
    };
  },
  mounted() {
  },
  methods: {},
};
